import { forwardRef } from 'react';

import { NodeManagerProvider } from './NodeManagerContext';

export const withNodeManager = () => (BaseComponent) =>
  forwardRef((props, ref) => {
    return (
      <NodeManagerProvider>
        <BaseComponent {...props} ref={ref} />
      </NodeManagerProvider>
    );
  });
